import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';

export const useDiscountBannerCopy = () => {
  const { discount, discountType, referralCredit, marketingReferral } = usePrenuvoStore(
    useShallow((state) => ({
      discount: state.payment.discount,
      discountType: state.payment.discountType,
      referralCredit: state.payment.referralCredit,
      marketingReferral: state.payment.marketingReferral,
    })),
  );

  const isValidDiscount = discountType === 'promo';

  if (
    !discountType ||
    !(discount || marketingReferral) ||
    Number(referralCredit?.balance) > Number(discount?.amount)
  ) {
    return { displayDiscountBanner: false, bannerCopy: '' };
  }

  const { promoName, promoValue } = isValidDiscount
    ? { promoName: discount?.actor, promoValue: discount?.amount }
    : { promoName: marketingReferral?.referrerName, promoValue: marketingReferral?.referralValue };

  let copyText;
  if (isValidDiscount && discount?.formattedBanner) {
    copyText = discount?.formattedBanner;
  } else if (promoName && promoName?.toLowerCase() !== 'prenuvo') {
    copyText = `${promoName} cares about you and so do we. That's why we're giving you $${promoValue} off your Whole Body scan. We're here to help you get the peace of mind you deserve.`;
  } else {
    copyText = `We're here to help you get the peace of mind you deserve. That's why we're giving you $${promoValue} off your Whole Body scan.`;
  }
  return { bannerCopy: copyText, displayDiscountBanner: true };
};
